import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabStripModule, PanelBarModule } from '@progress/kendo-angular-layout';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';

import { PipesModule } from '../pipes/pipes.module';
import { CgpTabbedFormDialogComponent } from './cgp-tabbed-form-dialog.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { CgpTabbedFormDialogService } from './cgp-tabbed-form-dialog.service';
import { SortableModule } from '@progress/kendo-angular-sortable';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ButtonGroupModule,
        ButtonsModule,
        CommonModule,
        TabStripModule,
        PanelBarModule,
        SwitchModule,
        NumericTextBoxModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        DialogModule,
        UploadModule,
        PipesModule,
        DateInputsModule,
        MatButtonModule,
        SortableModule
    ],
    declarations: [
        CgpTabbedFormDialogComponent,
    ],
    exports: [
        CgpTabbedFormDialogComponent
    ],
    providers: [
        CgpTabbedFormDialogService
    ]
})
export class CgpTabbedFormDialogModule { }
